import React, { useEffect, useRef, useState } from 'react';
// import { getResults } from '../../services/results/resultsService';
import { postFinalResultsFiles } from '../../../../services/results/resultsService';
import { Button } from '../../../../components/forms/Buttons/Button';
import CustomDialog from '../../../../components/modals/CustomDialog/CustomDialog';
import Select from '../../../../components/forms/Select/Select';
import { ArrowUpTrayIcon } from '@heroicons/react/24/solid';
import useSnackbar from '../../../../utils/hooks/useSnackbar';

export default function CREATE({ onCreate }) {
  // const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(false);
  const [open, setOpen] = useState(false);
  const { addSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [leg, setLeg] = useState(null);
  const [isAsp, setIsAsp] = useState(null);
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(null);
  const inputRef = useRef(null);

  const onClose = () => {
    setLeg(null);
    setIsAsp(null);
    setFile(null);
    setFileError(null);
    setOpen(false);
  };

  useEffect(() => {
    return () => {
      setFile(null);
      setFileError(null);
    };
  }, []);

  return (
    <>
      <Button text='Upload' onClick={() => setOpen(true)} />
      <CustomDialog
        isOpen={open}
        closeModal={() => {
          onClose();
        }}
      >
        <input
          className='border'
          type='file'
          accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
          ref={inputRef}
          onChange={(e, d) => {
            setFile(e.target.files[0]);
            // e.target.value = null;
          }}
        />
        <Select
          className='z-20'
          value={leg}
          isSearchable={false}
          options={[1, 2, 3, 4].map((v, i) => ({
            label: `${v} тур`,
            value: `${i}`,
          }))}
          placeholder='Тур'
          onChange={(e) => {
            setLeg(e.value);
          }}
        />
        <Select
          className='z-20'
          value={isAsp}
          isSearchable={false}
          options={[
            {
              label: 'ӘОТ',
              value: true,
            },
            {
              label: 'ӘОТ емес',
              value: false,
            },
          ]}
          placeholder='ӘОТ статус'
          onChange={(e) => {
            setIsAsp(e.value);
          }}
        />
        <Button
          Icon={ArrowUpTrayIcon}
          color='primary'
          className='h-9'
          text='Файлды жіберу'
          loading={loading}
          onClick={() => {
            if (isAsp !== null && leg !== null && file) {
              setLoading(true);
              const body = new FormData();
              body.append('file', file);
              body.append('round', leg);
              body.append('is_asp', isAsp);

              postFinalResultsFiles(body)
                .then((res) => {
                  if (onCreate) {
                    onCreate(res);
                  }
                  onClose();
                })
                // .catch(() => {
                //   addSnackbar(t('Ошибка'), 'error');
                // })
                .finally(() => {
                  setLoading(false);
                  setFile(null);
                  inputRef.current.value = null;
                  setLeg(null);
                  setIsAsp(null);
                });
            }
            if (file === null) {
              addSnackbar('Файлды таңдаңыз', 'error');
            } else if (isAsp === null || leg === null) {
              addSnackbar('Турды / ӘОТ таңдаңыз', 'error');
            }
          }}
        />
      </CustomDialog>
    </>
  );
}
